import amplitude from "amplitude-js";

//Send analytics event to the dashboard amplitude
export default (eventName: string, payload: {} = {}) => {
  amplitude.getInstance().logEvent(eventName, payload);
};
